<template>
  <div class="burger-wrapper">
    <button class="burger-button" @click="toggle">
      <span :class="[{ open }, 'burger']" />
    </button>

    <nav :class="[{ open }, 'menu']">
      <ul class="links">
        <li class="link" @click="go('how-it-works')">О сервисе</li>
        <li class="link" @click="go('features')">Возможности</li>
        <li class="link" @click="go('reviews')">Отзывы</li>
        <li class="link" @click="go('callback')">Связаться с нами</li>
        <li class="link" @click="go('faq')">FAQ</li>
      </ul>

      <div class="contacts">
        <a class="contact-link" href="tel:+375447228833">+375 44 722-88-33</a>
        <p class="contact-time">С 9 до 17 часов, в рабочие дни</p>
        <a class="contact-link" href="mailto:office@bytorg.by"
          >office@bytorg.by
        </a>
      </div>

      <div class="socials">
        <a :href="telegramLink" target="_blank" rel="noopener noreferrer">
          <Telegram ref="telegram" class="icon" />
        </a>

        <a :href="viberLink" target="_blank" rel="noopener noreferrer">
          <Viber ref="viber" class="icon" />
        </a>
      </div>

      <div class="buttons">
        <Button @click="openCallRequestModal">Обратный звонок</Button>
        <Button @click="clickLogIn" variant="outline">Войти</Button>
      </div>
    </nav>
  </div>
</template>

<script>
import Telegram from "@/assets/icons/telegram.svg";
import Viber from "@/assets/icons/viber.svg";
import Button from "./Button.vue";
import { purchasesPath } from "@/router/purchases";
import LoginModal from "@/components/homePage/LoginModal.vue";
import { LoginModalProperties } from "@/utils/modalsProperties";
import CallRequestModal from "@/components/homePage/CallRequestModal.vue";
import { CallRequestModalProperties } from "@/utils/modalsProperties";
import { telegramLink, viberLink } from "@/utils/constants/socialLinks";
import { mapGetters } from "vuex";

export default {
  name: "Burger",
  components: { Telegram, Viber, Button },
  data() {
    return { open: false, telegramLink, viberLink };
  },
  computed: {
    ...mapGetters("auth", ["isAuthenticated"]),
  },
  methods: {
    toggle() {
      if (!this.open) {
        window.scrollTo({ top: 0, behavior: "instant" });
      }

      this.open = !this.open;
      document.body.style.overflow = this.open ? "hidden" : "";
    },
    async go(id) {
      this.open = false;
      document.body.style.overflow = "";

      const isHome = this.$route.path === "/";

      if (!isHome) {
        await this.$router.push({ path: "/" });
      }

      this.$nextTick(() => {
        const el = document.getElementById(id);
        if (!el) return;

        const headerOffset = 88;
        const y =
          el.getBoundingClientRect().top + window.pageYOffset - headerOffset;

        window.scrollTo({
          top: y,
          behavior: "smooth",
        });
      });
    },
    openLoginModal() {
      document.body.style.overflow = "";
      this.$modal.show(LoginModal, null, LoginModalProperties);
    },

    clickLogIn() {
      this.isAuthenticated
        ? this.$router.push(purchasesPath)
        : this.openLoginModal();
      this.open = false;
    },
    openCallRequestModal() {
      document.body.style.overflow = "";
      this.$modal.show(CallRequestModal, null, CallRequestModalProperties);
      this.open = false;
    },
  },
};
</script>

<style scoped lang="less">
.burger-wrapper {
  display: none;
  @media (max-width: 767px) {
    display: block;
  }
  .burger-button {
    position: relative;
    width: 40px;
    height: 40px;
    background-color: transparent;
    border: none;
    cursor: pointer;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 0;
    .burger {
      width: 30px;
      height: 2px;
      border-radius: 999px;
      background-color: white;
      position: relative;
      transition: all 0.3s ease-in-out;
      &::before {
        content: "";
        position: absolute;
        top: -8px;
        left: 0;
        width: 30px;
        height: 2px;
        border-radius: 999px;
        background-color: white;
        transition: all 0.3s ease-in-out;
      }
      &::after {
        content: "";
        position: absolute;
        top: 8px;
        left: 0;
        width: 30px;
        height: 2px;
        border-radius: 999px;
        background-color: white;
        transition: all 0.3s ease-in-out;
      }
    }
    .burger.open {
      background-color: transparent;
      &::before {
        top: 0;
        transform: rotate(45deg);
      }
      &::after {
        top: 0;
        transform: rotate(-45deg);
      }
    }
  }
  .menu {
    position: fixed;
    top: 88px;
    left: 0;
    right: 0;
    bottom: 0;
    width: 100%;
    background-color: #484e55;
    z-index: 999;
    transform: translateX(100%);
    transition: transform 0.3s ease-in-out;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    padding: 0 40px;
    gap: 52px;
    overflow: auto;

    .links {
      display: flex;
      flex-direction: column;
      gap: 10px;
      .link {
        font-family: Montserrat;
        font-weight: 400;
        font-size: 18px;
        line-height: 1;
        text-align: left;
        color: #ffffff;
      }
    }

    .contacts {
      display: flex;
      flex-direction: column;
      gap: 12px;
      .contact-link {
        font-family: Montserrat;
        font-weight: 600;
        font-size: 24px;
        line-height: 1;
        color: white;
        text-decoration: none;
      }
      .contact-time {
        font-family: Montserrat;
        font-weight: 500;
        font-size: 14px;
        line-height: 1;
        color: white;
      }
    }

    .socials {
      display: flex;
      gap: 16px;
      height: 40px;
      .icon {
        color: #ffffff;
      }
    }

    .buttons {
      display: flex;
      flex-direction: column;
      gap: 24px;
      width: 100%;
    }
  }
  .menu.open {
    transform: translateX(0);
  }
}
</style>
